import styled from "styled-components";
import { useTranslation } from "react-i18next";

import { VoteStatus } from "types/voteEnum";

import ValidateButton from "./Buttons/ValidateButton";

type Props = {
    voteStatus: VoteStatus;
    handleValidate: () => void;
    handleReset?: () => void;
    canAnswerBeUpdated: boolean;
};

const ActionSection = ({
    voteStatus,
    handleValidate,
    handleReset,
    canAnswerBeUpdated,
}: Props) => {
    const { t } = useTranslation();

    const renderMessage = () => {
        switch (voteStatus) {
            case VoteStatus.PendingValidation:
                return <p>{t("answerNotValidated.quizzbox")}</p>;
            case VoteStatus.Success:
                return <p>{t("sentSucceded.quizzbox")}</p>;
            case VoteStatus.Loading:
                return <p>{t("loading")}</p>;
            case VoteStatus.Error:
                return <p>{t("errorUnknown")}</p>;
            default:
                return <p style={{ height: "16px" }}></p>;
        }
    };

    const shouldDisplayButton: boolean =
        voteStatus !== VoteStatus.Success || canAnswerBeUpdated;

    return (
        <Wrapper>
            {VoteStatus.Idle === voteStatus ? (
                <div style={{ height: "30px" }}></div>
            ) : (
                <Message
                    color={VoteStatus.Success === voteStatus ? "green" : "red"}
                >
                    <div>{renderMessage()}</div>
                </Message>
            )}
            {shouldDisplayButton && (
                <ValidateButton
                    isDisabled={VoteStatus.Idle === voteStatus}
                    onClick={
                        handleReset
                            ? VoteStatus.PendingValidation === voteStatus
                                ? handleValidate
                                : handleReset
                            : handleValidate
                    }
                    text={
                        VoteStatus.Success === voteStatus ? (
                            <span>{t("changeAnswer.quizzbox")}</span>
                        ) : (
                            <span>{t("validateAnswer.quizzbox")}</span>
                        )
                    }
                    color={
                        VoteStatus.Success === voteStatus
                            ? "#808080"
                            : "#60b860"
                    }
                />
            )}
        </Wrapper>
    );
};

const Wrapper = styled.div`
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    font-size: 14px;
    margin-top: 1rem;
`;

const Message = styled.div`
    color: ${(props) => props.color};
    width: 100%;
    text-align: center;
`;

export default ActionSection;
